export const PeronalityTriangle = ({
  color1,
  color2,
  color3,
}: {
  color1: string;
  color2: string;
  color3: string;
}) => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 421 315"
      width="200"
      height="150"
      style={{
        maxWidth: "100%",
        maxHeight: "200px",
        width: "auto",
        height: "auto",
        display: "block"
      }}
    >
      <polygon
        fill="none"
        points="-256.1 -67.8 -619.8 -67.8 -619.6 -68.2 -256.3 -68.2 -256.1 -67.8"
      />
      <polygon
        fill={color1}
        points="271.1 105.2 149.9 105.2 210.5 .2 271.1 105.2"
      />
      <polygon
        fill={color2}
        points="331.7 210.2 89.3 210.2 149.9 105.2 271.1 105.2 331.7 210.2"
      />
      <polygon
        fill={color3}
        points="392.2 314.8 28.8 314.8 89.3 210.2 331.7 210.2 392.2 314.8"
      />
    </svg>
  );
};
